const FONT_CLASS = {
  vi: 'hw-font-vi',
  en: 'hw-font-en',
  sg: 'hw-font-en',
  my: 'hw-font-en',
  ph: 'hw-font-en',
  in: 'hw-font-en',
  id: 'hw-font-id',
  hk: 'hw-font-hk',
  tw: 'hw-font-hk',
  th: 'hw-font-th',
}

export const halloweenFontClass = (locale) => FONT_CLASS[locale] || ''
